import { BRAND_TOKEN_REGISTRY } from "./tokenRegistry";

import type { BrandKitTokens } from "@/services/brandKitService";

// Imperative CSS-variable writer — the one mechanism every brand-kit phase reuses unchanged
// for Live Preview / Cancel / Apply / Reset. Never triggers a React re-render; mirrors the
// pattern src/theme/ThemeProvider.tsx already uses for dark-mode toast colors. See
// docs/plan/brand-kit/README.md §5.1.
export function applyTokensToDom(tokens: BrandKitTokens) {
  if (typeof document === "undefined") return;

  const root = document.documentElement;
  for (const definition of BRAND_TOKEN_REGISTRY) {
    const value = tokens[definition.key];
    if (value) {
      root.style.setProperty(definition.cssVariable, value);
    }
  }
}
